module.exports = __webpack_public_path__ + "img/visa-logo.922a1fa1.svg";